function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _createSuper(Derived) {
  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (_isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
/**
 * @description 文件选择组件
 */


import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import KZUIComponent from '../base';
import Large from './Large/index';
import Medium from './Medium/index';
import Small from './Small/index';
import Button from '../Button';
import { filterCopy } from '../utils';
import './style.less';

var checkImage = function checkImage(file) {
  return file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/gif' || file.type === 'image/jpg';
};

var FileSelect = /*#__PURE__*/function (_KZUIComponent) {
  _inherits(FileSelect, _KZUIComponent);

  var _super = _createSuper(FileSelect);

  function FileSelect(props) {
    var _this;

    _classCallCheck(this, FileSelect);

    _this = _super.call(this, props);
    _this.state = {
      url: _this.props.viewUrl,
      showImg: _this.props.viewUrl !== ''
    };

    _this.autoBind('handleChange', 'handleClick', 'handleDragOver', 'uploadFile', 'getComponent', 'replaceImg', 'deleteImg', 'getIcon');

    return _this;
  }

  _createClass(FileSelect, [{
    key: "handleClick",
    value: function handleClick(e) {
      if (e) {
        e.stopPropagation();
      }

      if (!this.props.disabled) {
        this.fileInput.click();
      }
    }
  }, {
    key: "uploadFile",
    value: function uploadFile(files) {
      if (this.props.multiple && files.length > this.props.maxFileCount) {
        return this.raiseError(1, '超过文件选择上限');
      }

      var cover = null;

      for (var i = 0; i < files.length; i += 1) {
        var file = files[i];

        if (this.props.maxFileSize && file.size > this.props.maxFileSize) {
          return this.raiseError(2, '超过大小上限');
        }

        if (!checkImage(file)) {
          return this.raiseError(3, '文件格式错误');
        }

        if (cover == null) {
          cover = file;
        }
      }

      if (this.props.onSelect) {
        this.props.onSelect(files);
      }
    }
  }, {
    key: "handleChange",
    value: function handleChange() {
      var files = this.fileInput.files;
      this.uploadFile(files);
      this.setState({
        url: '',
        showImg: false
      });
    }
  }, {
    key: "replaceImg",
    value: function replaceImg(e) {
      e.stopPropagation();
      this.handleClick();
    }
  }, {
    key: "deleteImg",
    value: function deleteImg(e) {
      e.stopPropagation();
      this.setState({
        showImg: false,
        url: ''
      });
    }
  }, {
    key: "getIcon",
    value: function getIcon() {
      var clsPrefix = 'kui-file-select';
      var icon = this.props.icon;

      switch (icon) {
        case 'pic':
          return /*#__PURE__*/React.createElement("i", {
            className: classNames("".concat(clsPrefix, "--icon"), 'kz-e-bianjiqi-picture')
          });

        case 'cloud':
          return /*#__PURE__*/React.createElement("i", {
            className: classNames("".concat(clsPrefix, "--icon"), 'kz-e-bianjiqi-up')
          });

        case 'add':
          return /*#__PURE__*/React.createElement("i", {
            className: classNames("".concat(clsPrefix, "--icon"), 'kz-e-add-new--1')
          });

        default:
          return null;
      }
    }
  }, {
    key: "getComponent",
    value: function getComponent() {
      var size = this.props.size;
      var clsPrefix = 'kui-file-select';
      var icon = this.getIcon();

      switch (size) {
        case 'large':
          return /*#__PURE__*/React.createElement(Large, {
            onClick: this.handleClick,
            onDrag: this.uploadFile,
            bottom: this.state.showImg,
            replaceImg: this.replaceImg,
            deleteImg: this.deleteImg,
            text: this.props.text
          }, this.state.showImg ? /*#__PURE__*/React.createElement("img", {
            src: this.props.viewUrl,
            className: "".concat(clsPrefix, "--bg"),
            ref: this.storeRef('bgfile'),
            alt: "bg"
          }) : null, icon);

        case 'medium':
          return /*#__PURE__*/React.createElement(Medium, {
            onClick: this.handleClick,
            text: this.props.text
          }, icon);

        case 'small':
          return /*#__PURE__*/React.createElement(Small, {
            onClick: this.handleClick,
            text: this.props.text
          }, icon);

        case 'button':
          return /*#__PURE__*/React.createElement(Button, {
            type: "primary",
            size: "normal",
            onClick: this.handleClick
          }, /*#__PURE__*/React.createElement("span", null, this.props.children));

        default:
          return null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      // const className = this.classname('file-select');
      var clsPrefix = 'kui-file-select';

      var _this$props = this.props,
          style = _this$props.style,
          className = _this$props.className,
          multiple = _this$props.multiple,
          others = _objectWithoutProperties(_this$props, ["style", "className", "multiple"]);

      var cls = classNames(clsPrefix, className);
      var extraProps = filterCopy(others, 'maxFileSize', 'maxFileCount', 'onSelect', 'onError', 'viewUrl', 'last');
      return /*#__PURE__*/React.createElement("div", _extends({}, extraProps, {
        className: cls,
        style: style
      }), this.getComponent(), /*#__PURE__*/React.createElement("input", {
        className: "".concat(clsPrefix, "-input"),
        ref: this.storeRef('fileInput'),
        type: "file",
        multiple: multiple,
        accept: this.props.accept,
        onChange: this.handleChange
      }));
    }
  }]);

  return FileSelect;
}(KZUIComponent);

FileSelect.defaultProps = {
  accept: 'image/jpeg, image/jpg, image/png',
  last: false,
  disabled: false,
  multiple: false,
  maxFileSize: 4194304,
  // 4MB
  maxFileCount: 1,
  onSelect: null,
  onError: null,
  viewUrl: '',
  icon: '',
  text: '',
  size: 'medium'
};
FileSelect.propTypes = {
  accept: PropTypes.string,
  last: PropTypes.bool,
  disabled: PropTypes.bool,
  multiple: PropTypes.bool,
  maxFileSize: PropTypes.number,
  maxFileCount: PropTypes.number,
  onSelect: PropTypes.func,
  onError: PropTypes.func,
  viewUrl: PropTypes.string,
  icon: PropTypes.string,
  text: PropTypes.string,
  size: PropTypes.oneOf(['small', 'medium', 'large', 'button'])
};
export default FileSelect;